const userInfo = {
  state: {
    user: {},
    autoShowBinduser: true,
    openId: ''
  },
  mutations: {
    set_userInfo_user (state, data) {
      state.user = data
    },
    set_userInfo_autoShowBinduser (state, data) {
      state.autoShowBinduser = data
    },
    set_userInfo_openId (state, data) {
      state.openId = data
    }
  },
  actions: {
  }
}
export default userInfo
